module.exports = "/_next/static/images/MultichannelMessaging@2x-0265b91d992c118e080dc827d1eb884d.png";